import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UpdateProbationRadio from '@/components/probation-status-radio.vue';
import { addFn, updateFn, searchStaffFn, getCallTypeUrlMethod, getSexUrlMethod, getCountries } from 'api/org/per';
import { getRegularEnv } from 'api/dashboard';
import { countries } from 'api/login';
import depTree from '@/components/dep-tree';
import { v4 as uuidv4 } from 'uuid';
var dataForm = function dataForm() {
  return {
    first_name: '',
    // 员工姓名
    first_name_en: '',
    // 员工英文名
    call_type: '',
    // 称谓
    call_type_en: '',
    // 英文称谓
    last_name: '',
    // 姓
    last_name_en: '',
    // 英文姓
    mobile: '',
    // 手机号
    department_name: '',
    // 部门名称
    department_id: '',
    // 部门id
    job_title_id: '',
    // 职位id
    hire_date: '',
    // 入职日期
    leave_date: '',
    // 离职日期
    state: '1',
    // 在职状态 员工状态
    formal: '',
    // 员工属性s
    manager_id: '',
    // 直线上级id
    formal_date: '',
    // 转正日期
    staff_code: '',
    // 员工工号
    personal_email: '',
    // 个人邮箱
    enterprise_email: '',
    // 企业邮箱
    line_id: '',
    // LINR ID
    remark: '',
    // 备注
    settlement_type: '',
    // 结算类型
    salary_method: '',
    // 发薪方式,
    is_register_user: '',
    address: {
      country: 'TH',
      province: '',
      city: '',
      district: '',
      postal_code: '',
      door_number: '',
      village_no: '',
      village: '',
      lane: '',
      road: '',
      formated_address: ''
    },
    birth_date: '',
    call_type_txt: '',
    formal_name: '',
    id: '',
    id_card_no: '',
    job_title_name: '',
    manager_name: '',
    mobile_country_code: '66',
    nationality: '',
    nationality_txt: '',
    settlement_type_name: '',
    sex: '',
    sex_txt: '',
    staff_id: '',
    state_name: '',
    stop_duties_date: null,
    work_address: '',
    formal_state: '1',
    probation_day: '',
    register_country: '1' // 国家
  };
};

export default {
  props: {
    sysInfoArr: {
      type: Object,
      default: function _default() {
        return {
          state: [],
          // 在职状态   1-在职 2-离职 3-待离职 4-停职
          salary_method: [],
          // 发薪方式
          settlement_type: [],
          // 结算类型
          formal: [] // 员工属性
        };
      }
    },

    posiAllList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    operateType: {
      type: String,
      default: ''
    }
  },
  components: {
    depTree: depTree
  },
  data: function data() {
    var self = this;
    return {
      visible: false,
      disabled: false,
      popover: false,
      positionOptions: [],
      supLoading: false,
      supOptions: [],
      dataForm: dataForm(),
      cDataForm: {},
      callTypeListDefault: [],
      // 当前语言环境称谓
      callTypeListEn: [],
      // 英文称为
      sexList: [],
      // 性别列表
      countriesList: {},
      // 国籍列表
      dataRule: {
        first_name: [{
          required: true,
          message: this.$t('1256')
        }],
        last_name: [{
          required: true,
          message: this.$t('1256')
        }],
        mobile: [{
          required: true,
          message: this.$t('241')
        }],
        department_id: [{
          required: true,
          message: this.$t('794')
        }],
        hire_date: [{
          required: true,
          message: this.$t('795')
        }],
        leave_date: [{
          required: true,
          message: this.$t('795')
        }],
        stop_duties_date: [{
          required: false,
          message: this.$t('1820')
        }],
        id_card_no: [{
          required: false,
          message: this.$t('1339')
        }],
        settlement_type: [{
          required: true,
          message: this.$t('796')
        }],
        salary_method: [{
          required: true,
          message: this.$t('797')
        }],
        state: [{
          required: true,
          message: this.$t('799')
        }],
        formal: [{
          required: true,
          message: this.$t('800')
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 离职日期、转正日期、停职日期在hire_date之后可以选择
          var hire_date = new Date(self.dataForm.hire_date).getTime() - 86400000;
          return time.getTime() < hire_date;
        }
      },
      register_country_list: []
    };
  },
  computed: {
    isView: function isView() {
      return this.operateType === 'view';
    },
    title: function title() {
      if (this.operateType === 'view') return this.$t('64');else return this.dataForm.staff_id ? this.$t('13') : this.$t('344');
    }
  },
  methods: {
    init: function init(item) {
      var _this = this;
      // 获取称谓列表 eslint-disable-next-line
      getCallTypeUrlMethod().then(function (res) {
        if (res.data) {
          _this.callTypeListDefault = res.data.default;
          _this.callTypeListEn = res.data.en;
        }
      });
      // 获取国家列表
      getCountries().then(function (res) {
        _this.register_country_list = res === null || res === void 0 ? void 0 : res.data;
      });
      // 获取性别列表 eslint-disable-next-line
      getSexUrlMethod().then(function (res) {
        return _this.sexList = res && res.data;
      });
      // 获取国籍列表 eslint-disable-next-line
      countries().then(function (res) {
        return _this.countriesList = res && res.data;
      });
      this.visible = true;
      this.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, result, lresult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.$refs.dataForm.resetFields();
              _this.dataForm = item && JSON.parse(JSON.stringify(_objectSpread(_objectSpread({}, dataForm()), item))) || dataForm();
              // 获取试用期天数
              if (!(_this.operateType === 'create')) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return getRegularEnv({
                code: 'STAFF_PROBATION_DAY'
              });
            case 5:
              res = _context.sent;
              if (res && res.code && !_this.dataForm.probation_day) _this.dataForm.probation_day = res.data;
            case 7:
              _this.dataForm.formal_state = !_this.dataForm.formal_state || _this.dataForm.formal_state === '0' ? '1' : _this.dataForm.formal_state;
              _this.$nextTick(function () {
                return _this.$refs.dataForm.clearValidate();
              });
              result = item && item.job_title_id && [{
                job_title_name: item.job_title_name,
                id: item.job_title_id
              }];
              _this.positionOptions = result || [];
              lresult = item && item.manager_id && [{
                staff_name: item.manager_name,
                staff_id: item.manager_id
              }];
              _this.supOptions = lresult || [];
              _this.handleState();
              if (_this.operateType === 'edit' && _this.dataForm.staff_id) {
                _this.dataRule.id_card_no[0].required = item.nationality === 'TH';
              }
              if (_this.dataForm.hire_date && _this.dataForm.probation_day && !_this.dataForm.formal_date) {
                _this.handleProbation(_this.dataForm.probation_day, _this.dataForm.hire_date);
              }
              _this.cDataForm = JSON.parse(JSON.stringify(_this.dataForm));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    },
    // 泰国 身份证号必填
    changeIdCardNo: function changeIdCardNo(item) {
      this.dataRule.id_card_no[0].required = item === 'TH';
    },
    // 称谓同步
    handlerChangeCallType: function handlerChangeCallType(params) {
      // console.log(params)
      this.dataForm.call_type_en = params;
    },
    handleState: function handleState() {
      if (['1', '4'].includes(this.dataForm.state)) {
        this.dataForm.leave_date = '';
        this.dataRule.leave_date[0].required = false;
      } else {
        this.dataRule.leave_date[0].required = true;
      }
      var state = this.dataForm.state !== '4';
      if (state) this.dataForm.stop_duties_date = '';
      this.dataRule.stop_duties_date[0].required = !state;
    },
    // 出生日期禁选项 必须大于当前日期
    disabledDate: function disabledDate(t) {
      return new Date().getTime() < t.getTime();
    },
    handleNodeClick: function handleNodeClick(val) {
      this.dataForm.department_id = val.department_id;
      this.dataForm.department_name = val.department_name;
      this.popover = false;
    },
    onProbationDay: function onProbationDay(v) {
      // 试用期天数
      if (this.dataForm.hire_date) {
        this.handleProbation(v, this.dataForm.hire_date);
      }
    },
    onHireDate: function onHireDate(v) {
      // 入职日期
      if (!v) {
        this.dataForm.formal_date = '';
        return;
      }
      this.handleProbation(this.dataForm.probation_day, v);
    },
    handleProbation: function handleProbation(v, hire) {
      if (['edit', 'view'].includes(this.operateType)) return;
      // 填写了“试用期(天)”，自动计算：转正日期=入职日期+试用期(天)——入职日期为第0天
      if (!String(v)) return;
      var day = Number(v);
      var hireData = new Date(hire);
      hireData.setDate(hireData.getDate() + day);
      this.dataForm.formal_date = this.formatDay(hireData);
    },
    // 时间戳转换为日期 2020-09-08
    formatDay: function formatDay(timestamp) {
      var date = new Date(timestamp);
      var YY = date.getFullYear();
      var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return "".concat(YY, "-").concat(MM, "-").concat(DD);
    },
    changeDormal: function changeDormal(v) {
      var _this2 = this;
      // 修改转正日期
      // 当转正日期是今天(含)之前的日期，提交时则提示：转正日期已过，是否确认为「已转正」？
      var newTime = new Date().getTime();
      var selectTime = new Date(v).getTime();
      if (selectTime < newTime && this.dataForm.formal_date && this.operateType === 'create') {
        this.dataForm.formal_state = '1';
        var h = this.$createElement;
        var formal_state;
        this.$msgbox({
          title: this.$t('229'),
          message: h(UpdateProbationRadio, {
            // see https://github.com/ElemeFE/element/issues/8931
            key: uuidv4(),
            on: {
              change: function change(v) {
                formal_state = v;
              }
            }
          }),
          distinguishCancelAndClose: true,
          showCancelButton: true,
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          customClass: 'probation-msg-box'
        }).then(function () {
          _this2.dataForm.formal_state = formal_state;
          if (formal_state === '1') {
            _this2.dataForm.formal_date = _this2.cDataForm.formal_date || _this2.dataForm.formal_date;
          }
          _this2.ajaxFn();
        }).catch(function (action) {
          // if (action === 'close') return
          // this.dataForm.formal_state = '1'
          // this.dataForm.formal_date = this.cDataForm.formal_date || this.dataForm.formal_date
          // this.ajaxFn()
        });
      } else {
        this.ajaxFn();
      }
    },
    positionRemoteMethod: function positionRemoteMethod(query) {
      this.positionOptions = query !== '' ? this.posiAllList.filter(function (v) {
        return v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1;
      }) : [];
    },
    supRemoteMethod: function supRemoteMethod(query) {
      var _this3 = this;
      if (query !== '') {
        this.supLoading = true;
        // ajax请求
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(function (res) {
            _this3.supLoading = false;
            if (res && res.code === 1) {
              _this3.supOptions = res.data.map(function (v) {
                return {
                  staff_name: v.staff_name,
                  staff_id: v.staff_id
                };
              });
            }
          });
        }, 300);
      } else {
        this.supOptions = [];
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this4.changeDormal(_this4.dataForm.formal_date);
        }
      });
    },
    ajaxFn: function ajaxFn() {
      var _this5 = this;
      this.disabled = true;
      var payload = JSON.parse(JSON.stringify(this.dataForm));
      // 编辑的时候不需要传formal_state
      if (this.dataForm.staff_id) {
        delete payload.formal_state;
      }
      var api = this.dataForm.staff_id ? updateFn(payload) : addFn(payload);
      api.then(function (res) {
        if (res && res.code === 1) {
          _this5.visible = false;
          _this5.$message.success(res.message);
          _this5.dataForm = dataForm();
          _this5.$emit('refreshTableList');
        }
      }).catch(function (err) {
        if (err.code === 2010) {
          _this5.visible = false;
          _this5.$emit('refreshTableList');
        }
      }).finally(function () {
        return _this5.disabled = false;
      });
    },
    departmentClear: function departmentClear() {
      this.dataForm.department_id = null;
    }
  }
};